import React from "react";
import "./style.css";

function Footer() {
  return (
    <footer className="footer text-center">
      <span>Angelina Ma</span>
    </footer>
  );
}

export default Footer;
